import {V2_FIELDS} from './contactSchema.js'

export const DOMAIN_ERROR_KEYS = {
  CONTACT_VALIDATION: 'CONTACT_VALIDATION_SELLER_ERROR',
  EMPTY_NAME: 'EMPTY_NAME_SELLER_ERROR',
  EMPTY_EMAIL: 'EMPTY_EMAIL_SELLER_ERROR',
  INVALID_EMAIL: 'INVALID_EMAIL_SELLER_ERROR',
  INVALID_PHONE: 'INVALID_PHONE_SELLER_ERROR',
  GENERIC: 'GENERIC_SELLER_SELLER_ERROR'
}

const EMPTY_RESULT = {fieldErrors: {}, hasGenericError: false, hasCaptchaError: false}

const isInstanceOf = (error, ErrorClass) => Boolean(ErrorClass) && error instanceof ErrorClass

export const mapDomainErrorToFields = ({error, errors = {}}) => {
  if (!error) {
    return EMPTY_RESULT
  }

  const domainErrors = error.getErrors?.()

  if (!domainErrors) {
    return {...EMPTY_RESULT, hasGenericError: true}
  }

  const hasNameError = domainErrors.some(err => isInstanceOf(err, errors[DOMAIN_ERROR_KEYS.EMPTY_NAME]))
  const hasEmailError = domainErrors.some(
    err =>
      isInstanceOf(err, errors[DOMAIN_ERROR_KEYS.EMPTY_EMAIL]) ||
      isInstanceOf(err, errors[DOMAIN_ERROR_KEYS.INVALID_EMAIL])
  )
  const hasPhoneError = domainErrors.some(err => isInstanceOf(err, errors[DOMAIN_ERROR_KEYS.INVALID_PHONE]))
  const hasGenericError = domainErrors.some(err => isInstanceOf(err, errors[DOMAIN_ERROR_KEYS.GENERIC]))

  const hasCaptchaError = domainErrors.some(err => isInstanceOf(err, errors[DOMAIN_ERROR_KEYS.CONTACT_VALIDATION]))

  const recognised = hasNameError || hasEmailError || hasPhoneError || hasGenericError || hasCaptchaError

  return {
    fieldErrors: {
      ...(hasNameError && {[V2_FIELDS.NAME]: true}),
      ...(hasEmailError && {[V2_FIELDS.EMAIL]: true}),
      ...(hasPhoneError && {[V2_FIELDS.PHONE]: true})
    },
    hasCaptchaError,
    hasGenericError: hasGenericError || !recognised
  }
}

export default mapDomainErrorToFields
